import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { ANNUAL_REPORT_API } from "./apiRoutes";

const mutateAddAnnualReporting = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${ANNUAL_REPORT_API}/`, data);
};

const useAddAnnualReportingMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddAnnualReporting,
    ...queryParams,
  });

export default useAddAnnualReportingMutation;
